import { Controller, useFormContext } from "react-hook-form";

import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { CustomInputField, CustomSelect } from "@/features/ui";

export const EntityTaxInformationSection = () => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container spacing={3}>
        <Grid size={12}>
          <Typography variant="h6">Pajak</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="taxIdentificationNumber"
            label="NPWP"
            register={register}
            helperText={errors.taxIdentificationNumber?.message}
            error={Boolean(errors.taxIdentificationNumber)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="taxpayerName"
            label="Nama Wajib Pajak"
            register={register}
            helperText={errors.taxpayerName?.message}
            error={Boolean(errors.taxpayerName)}
            InputProps={{
              placeholder: "Cth: John Doe",
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="identityNumber"
            label="NIK/Paspor"
            register={register}
            helperText={errors.identityNumber?.message}
            error={Boolean(errors.identityNumber)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Controller
            control={control}
            name="defaultTaxIncluded"
            render={({ field, fieldState }) => (
              <CustomSelect
                required
                value={field.value}
                onChange={field.onChange}
                id="defaultTaxIncluded"
                label="Default faktur termasuk pajak"
                options={Object.values([
                  { value: true, label: "Ya" },
                  { value: false, label: "Tidak" },
                ]).map((option) => ({
                  value: option.value,
                  label: option.label,
                }))}
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 8, lg: 6 }}>
          <CustomInputField
            control={control}
            name="taxInformationAddress"
            label="Alamat"
            register={register}
            helperText={errors.taxInformationAddress?.message}
            error={Boolean(errors.taxInformationAddress)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="taxInformationPostalCode"
            label="Kode POS"
            register={register}
            helperText={errors.taxInformationPostalCode?.message}
            error={Boolean(errors.taxInformationPostalCode)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="taxInformationCity"
            label="Kota"
            register={register}
            helperText={errors.taxInformationCity?.message}
            error={Boolean(errors.taxInformationCity)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="taxInformationProvince"
            label="Provinsi"
            register={register}
            helperText={errors.taxInformationProvince?.message}
            error={Boolean(errors.taxInformationProvince)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="taxInformationCountry"
            label="Negara"
            register={register}
            helperText={errors.taxInformationCountry?.message}
            error={Boolean(errors.taxInformationCountry)}
          />
        </Grid>
      </Grid>
  );
};

export default EntityTaxInformationSection;
